import React, { Fragment } from 'react';
import {
  IAvailabilityRange,
  ICourseModeApi,
  IFieldTabEditorState,
  IGameConfigEditor
} from '../containers/academicComponentEditorFunctions';
import { useTranslation } from 'react-i18next';
import { useColors } from 'app_hooks/useColors';
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent';
import { AiOutlineCamera } from 'react-icons/ai';
import { Form } from 'react-bootstrap'
import { getDataTypeFieldEditor } from '../containers/academicComponentEditorFunctions';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';

export interface RenderFieldByNameEditorProps {
  field: IFieldTabEditorState
  disableAll?: boolean
  disableEditDuration?: boolean
  courseModes?: ICourseModeApi[]
  idx: number
  disabledFields?: string[]
  onChangeField: (idxTab: number, idField: string, e: any) => void
  onChangeAvailabilityRange: (idxTab: number, idField: string, e: any, type: 'date' | 'hour') => void
  getValueFromDate: (date: Date, type: 'date' | 'hour') => string
  onChangeGameConfig: (idxTab: number, idField: string, e: any) => void
  handleClickCheckBox: (idx: number, idField: string) => void
  handleUploadFile: (event: any, idx: number, idField: string) => void
  handleChangePickerComplete: (color: any, idx: number, idField: string) => void
  onChangeReactSelect: (idxTab: number, idField: string, data: IOptionSelect[]) => any
}

interface IOptionSelect {
  label: string
  value: string
}

const RenderFieldByNameEditor: React.SFC<RenderFieldByNameEditorProps> = (props) => {

  const { t } = useTranslation()
  const [colors] = useColors()

  /**
   * @INFO Organizar la data para devolver de un select
   */
  const handleChangeReactSelect = (data: IOptionSelect[]) => {
    if (props.onChangeReactSelect) {
      props.onChangeReactSelect(props.idx, props.field.id, [...data])
    }
  }

  const getCourseModesOptions = () => {
    return [
      { name: 'Caracterización', _id: 'characterization-survey' },
      { name: 'Cursos autogestionados', _id: 'withoutTutor-survey' },
      ...(props.courseModes?.length ? props.courseModes : []),
    ]
  }

  if (props.disabledFields?.includes(props.field.type)) {
    return null
  }

  return (
    <Fragment key={props.field.id}>
      {props.field.type === 'title' ||
        props.field.type === 'virtual_tutoring_external_link' ||
        props.field.type === 'virtual_tutoring_access_password' ||
        props.field.type === 'virtual_tutoring_record_link' ?
        <>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <div className='input-group mb-3'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} type='text' className='form-control' />
          </div>
        </>
        : null
      }
      {props.field.type === 'date' ?
        <>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <div className='input-group mb-3'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} type='date' className='form-control' />
          </div>
        </>
        : null
      }
      {props.field.type === 'datetime' ?
        <>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <div className='input-group mb-3'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} type='datetime-local' className='form-control' />
          </div>
        </>
        : null
      }
      {
        props.field.type === 'duration' ||
          props.field.type === 'time_limit' ?
          <>
            <LabelComponent>
              {t(`editor.editor_panel.fields.${props.field.type}`)}
            </LabelComponent>
            <div className='input-group mb-3'>
              <input disabled={props.disableAll || props.disableEditDuration} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} type='text' placeholder='0h 0m 0s' className='form-control' />
            </div>
          </>
          : null
      }
      {
        props.field.type === 'max_attemps' ||
          props.field.type === 'number_questions_section' ||
          props.field.type === 'value_component'
          ?
          <>
            <LabelComponent>
              {t(`editor.editor_panel.fields.${props.field.type}`)}
            </LabelComponent>
            <div className='input-group mb-3'>
              <input disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} type='number' className='form-control' />
            </div>
          </>
          : null
      }
      {props.field.type === 'availability_range' ?
        <>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <p className='label-field mt-0'>{t(`editor.editor_panel.fields.from`)}:</p>
          <div className='input-group mb-0'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeAvailabilityRange(props.idx, props.field.id, e, 'date')} name='start' value={props.getValueFromDate((props.field.value as IAvailabilityRange).start, 'date')} placeholder='Inicio' type='date' className='form-control' />
            <input disabled={props.disableAll} onChange={(e) => props.onChangeAvailabilityRange(props.idx, props.field.id, e, 'hour')} name='start' value={props.getValueFromDate((props.field.value as IAvailabilityRange).start, 'hour')} placeholder='Inicio' type='time' className='form-control' />
          </div>
          <p className='label-field mt-0'>{t(`editor.editor_panel.fields.to`)}:</p>
          <div className='input-group mb-3'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeAvailabilityRange(props.idx, props.field.id, e, 'date')} name='end' value={props.getValueFromDate((props.field.value as IAvailabilityRange).end, 'date')} placeholder='Fin' type='date' className='form-control' />
            <input disabled={props.disableAll} onChange={(e) => props.onChangeAvailabilityRange(props.idx, props.field.id, e, 'hour')} name='end' value={props.getValueFromDate((props.field.value as IAvailabilityRange).end, 'hour')} placeholder='Fin' type='time' className='form-control' />
          </div>
        </>
        : null
      }
      {props.field.type === 'game' ?
        <>
          <p className='label-strong-big'>{t(`editor.editor_panel.fields.${props.field.type}`)}</p>
          <p className='label-field'>Numero de items</p>
          <div className='input-group'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeGameConfig(props.idx, props.field.id, e)} name='number_of_items' value={(props.field.value as IGameConfigEditor)?.algorithm?.number_of_items} placeholder='Numero de items' type='number' className='form-control' />
          </div>
          {props.field.required && props.field.invalid ? <p className='label-obligatory-input mt-0' >Obligatorio</p> : null}
        </>
        : null
      }
      {props.field.type === 'game' ?
        <>
          <p className='label-field'>Probabilidad teórica</p>
          <div className='input-group mb-3'>
            <input disabled={props.disableAll} onChange={(e) => props.onChangeGameConfig(props.idx, props.field.id, e)} name='theoretical_probability' value={(props.field.value as IGameConfigEditor)?.algorithm?.theoretical_probability} placeholder='Probabilidad teórica' type='number' className='form-control' />
          </div>
        </>
        : null
      }
      {props.field.type === 'description' ?
        <>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <div className='input-group mb-3'>
            <textarea disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} id='description' className='form-control' aria-label='With textarea'></textarea>
          </div>
        </>
        : null
      }
      {
        props.field.type !== 'active' && props.field.type !== 'is_characterization_survey' &&
          getDataTypeFieldEditor(props.field.type) === 'boolean'
          ?
          <>
            <div className='form-check' style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
              <CheckBoxComponent
                onClick={() => props.handleClickCheckBox(props.idx, props.field.id)}
                checked={props.field.value as boolean}
                disabled={props.disableAll}
              />
              <label className='form-check-label' htmlFor={props.field.id}>
                {t(`editor.editor_panel.fields.${props.field.type}`)}
              </label>
            </div>
          </>
          : null
      }
      {props.field.type === 'icon' ?
        <>
          <div className='col-case-img'>
            <p>{t(`editor.editor_panel.fields.${props.field.type}`)}</p>
            <div style={{ backgroundImage: `url(${typeof props.field.value === 'string' ? props.field.value : props.field.urlLocal as string})` }} className='img-div-case'>
              {props.disableAll ? null : <div className='bg-upload-img'>
                <label htmlFor={props.field.id}>
                  <AiOutlineCamera className='camera-icon-upload' />
                </label>
              </div>}
            </div>
            <input disabled={props.disableAll} type='file' onChange={(e) => props.handleUploadFile(e, props.idx, props.field.id)} id={props.field.id} style={{ display: 'none' }} />
          </div>
        </>
        : null
      }
      {props.field.type === 'background' ?
        <>
          <div className='col-portrait-img'>
            <p>{t(`editor.editor_panel.fields.${props.field.type}`)}</p>
            <div style={{ backgroundImage: `url(${typeof props.field.value === 'string' ? props.field.value : props.field.urlLocal as string})` }} className='img-div-portrait'>
              {props.disableAll ? null : <div className='bg-upload-img'>
                <label htmlFor={props.field.id}>
                  <AiOutlineCamera className='camera-icon-upload' />
                </label>
              </div>}
            </div>
            <input disabled={props.disableAll} type='file' onChange={(e) => props.handleUploadFile(e, props.idx, props.field.id)} id={props.field.id} style={{ display: 'none' }} />
          </div>
        </>
        : null
      }
      {/* </div> */}
      {/* {props.field.type === 'color' ?
        <>
          <ColorPickerEditorComponent
            label={t(`editor.editor_panel.fields.${props.field.type}`)}
            value={props.field.value as string}
            onChange={(color: any) => props.handleChangePickerComplete(color, props.idx, props.field.id)}
            disabled={props.disableAll}
          />
        </>
        : null
      } */}
      {props.field.type === 'course_modes' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control
                disabled={props.disableAll}
                onChange={(e) => props.onChangeField(props.idx, props.field.id, e)}
                value={props.field.value as string}
                as='select'
                custom
              >
                <option>-- Modalidad --</option>
                {getCourseModesOptions()?.length ?
                  getCourseModesOptions().map((item) => (
                    <option
                      value={item._id}
                      key={item._id}
                    >
                      {item.name}
                    </option>
                  ))
                :null}
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
      : null}
      {props.field.type === 'course_type' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control
                disabled={props.disableAll}
                onChange={(e) => props.onChangeField(props.idx, props.field.id, e)}
                value={props.field.value as string}
                as='select'
                custom
              >
                <option value="">-- Tipo de curso --</option>
                <option value="free">Gratuito</option>
                <option value="mooc">Mooc</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
      : null}
      {props.field.type === 'alliance' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} as='select' custom>
                <option>Kuepa EduTech</option>
                <option>IQ Primaria</option>
                <option>Barna</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
        : null}
      {props.field.type === 'program' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} as='select' custom>
                <option>Bachillerato virtual</option>
                <option>Ingles</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
        : null}
      {props.field.type === 'cycle' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} as='select' custom>
                <option>Ciclo V</option>
                <option>Ciclo X</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
        : null}
      {props.field.type === 'level' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} as='select' custom>
                <option>-- Elige una opción --</option>
                <option value='value1' >Nivel 1</option>
                <option value='value2' >Nivel 2</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
        : null}
      {props.field.type === 'save_progress' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} as='select' custom>
                <option>Si</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
        : null}
      {props.field.type === 'order_of_questions' ?
        <div>
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <Form>
            <Form.Group>
              <Form.Control disabled={props.disableAll} onChange={(e) => props.onChangeField(props.idx, props.field.id, e)} value={props.field.value as string} as='select' custom>
                <option value='' >-- Elige una opción --</option>
                <option value='ordered' >Ordenadas</option>
                <option value='random' >Aleatorias</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </div>
        : null}
      {/* {props.field.type === 'components_related' ?
        <div className="mb-3">
          <LabelComponent>
            {t(`editor.editor_panel.fields.${props.field.type}`)}
          </LabelComponent>
          <MultiSelectEditor
            options={props.field.options as IOptionSelect[]}
            onChange={handleChangeReactSelect}
            disableAutoOption
            disabled={props.disableAll}
            placeholder={t(`editor.editor_panel.fields.${props.field.type}`)}
            defaultValue={props.field.value as IOptionSelect[]}
          />
        </div>
        : null} */}
      {props.field.required && props.field.invalid && props.field.type !== 'icon' && props.field.type !== 'background' ? <p className='label-obligatory-input' >Obligatorio</p> : null}
    </Fragment>
  );
}

export default RenderFieldByNameEditor;
